//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StarRating from 'vue-star-rating'

export default {
    components: {
        StarRating,
    },
    props: {
        formEl: { type: Object },
        readOnly: { type: Boolean, default: false },
        small: { type: Boolean, default: false },
        rating: { type: Number, default: 0 },
    },
    methods: {
        onRating(rating) {
            this.$emit('rating', rating)
        },
    },
}
